import styles from "./style.module.scss";
import Fishing from "src/assets/fishing.jpg";
import { Link } from "react-router-dom";

export const FishingSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <div className={styles.imageBox}>
          <img src={Fishing} alt="fhishing" />
          <p>Fishing</p>
        </div>

        <h3>釣り船に乗って旬の魚をフィッシング</h3>
        <p className={styles.description}>
          石巻の海を知り尽くしたガイドが、魚がよく釣れるポイントへ船でご案内。釣具レンタルも充実しており、手ぶらでも参加可能です。釣った魚はその場で捌き、海の新鮮な味も堪能できます。釣る喜びと食べる楽しさをフルで体感でき、海がより身近に感じる体験です。
        </p>

        <Link to="/activity#fishing" className={styles.link}>
          more
        </Link>
      </div>
    </section>
  );
};
